import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconStaticReminderBirthday = function IconStaticReminderBirthday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2.818 2.727v3.636M1 4.545h3.636m31.819.91V9.09m-1.819-1.817h3.637"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.364,
    cy: 0.909,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.818,
    cy: 33.636,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.091,
    cy: 11.818,
    r: 0.909,
    fill: "#00204D"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M9.182 34.545v3.637m-1.818-1.818H11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.273 21.198V30h23.454v-8.877a1.125 1.125 0 0 0-1.817-.887c-.628.584-1.6.584-2.229 0l-.703-.654a1.636 1.636 0 0 0-2.229 0l-.702.654a1.638 1.638 0 0 1-2.23 0l-.702-.654a1.636 1.636 0 0 0-2.23 0l-.702.654a1.638 1.638 0 0 1-2.23 0l-.702-.654a1.636 1.636 0 0 0-2.229 0l-.703.654a1.636 1.636 0 0 1-2.198.027 1 1 0 0 0-.065-.05 1.163 1.163 0 0 0-1.783.985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M8.273 18v.545l1.817 1.69a1.636 1.636 0 0 0 2.23 0l.702-.653a1.636 1.636 0 0 1 2.23 0l.702.654c.628.584 1.6.584 2.229 0l.703-.654a1.636 1.636 0 0 1 2.229 0l.703.654c.628.584 1.6.584 2.229 0l.702-.654a1.636 1.636 0 0 1 2.23 0l.702.654a1.636 1.636 0 0 0 2.23 0l1.816-1.69V18a4.364 4.364 0 0 0-4.363-4.364H12.637A4.364 4.364 0 0 0 8.273 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    d: "M8.273 30h-1a1 1 0 0 0 1 1zm1-11.818a1 1 0 1 0-2 0zM31.909 30v1a1 1 0 0 0 1-1zM10.65 13.025a1 1 0 1 0 .745 1.856zM9.273 30V18.182h-2V30zm3.397-15.364h14.842v-2H12.67zM30.91 18v12h2V18zm1 11H8.272v2h23.636zm-4.398-14.364c1.883 0 3.397 1.513 3.397 3.364h2c0-2.97-2.424-5.364-5.397-5.364zm-16.118.245a3.4 3.4 0 0 1 1.276-.245v-2c-.713 0-1.396.138-2.021.39z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m8.273 18.182 1.343 2.066a1.758 1.758 0 0 0 3.02-.121l.069-.127c.635-1.173 2.319-1.173 2.954 0s2.32 1.173 2.955 0 2.319-1.173 2.954 0 2.32 1.173 2.955 0 2.319-1.173 2.954 0l.07.127a1.758 1.758 0 0 0 3.02.12l1.342-2.065"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00204D",
    strokeWidth: 2,
    d: "M8.273 25.454h23.636"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00204D",
    strokeWidth: 2,
    d: "M18.364 10.182a1 1 0 0 1 1-1h2.363a1 1 0 0 1 1 1v3.363h-4.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC640D",
    stroke: "#00204D",
    strokeWidth: 1.5,
    d: "m18.975 5.193 1.48-2.466L22.01 5.12a1.8 1.8 0 0 1-.264 2.274 1.785 1.785 0 0 1-2.771-2.201Z"
  }));
};